/**
 * AutoTemplateDialog — create/copy dialog wrapping AutoTemplateConfigForm.
 *
 * Extracted as-is from BlogTemplatesPage (Phase 1 decomposition).
 */

import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { AutoTemplateConfigForm, type AutoTemplateFormData } from '@/components/blog-templates/AutoTemplateConfigForm';

export interface AutoTemplateDialogProps {
  open: boolean;
  isCreating: boolean;
  initialData?: Partial<AutoTemplateFormData>;
  onSave: (config: AutoTemplateFormData) => void;
  onOpenChange: (open: boolean) => void;
}

export const AutoTemplateDialog: React.FC<AutoTemplateDialogProps> = ({
  open,
  isCreating,
  initialData,
  onSave,
  onOpenChange,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl max-h-[85vh] flex flex-col">
        <DialogHeader>
          <DialogTitle>{initialData ? 'Copy Auto Template' : 'Create Auto Template'}</DialogTitle>
          <DialogDescription>
            Configure global settings for AI-generated content structure
          </DialogDescription>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto">
          <AutoTemplateConfigForm
            onSave={onSave}
            onCancel={() => onOpenChange(false)}
            initialData={initialData}
            isLoading={isCreating}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
